import React from 'react';
import ReactApexChart from 'react-apexcharts';

const MostUsedFeature = ({ mostViewedPages = [] }) => {
    const validPages = mostViewedPages.filter(item => item.PageName != null);
    
    const doughnutSeries = validPages.map(item => parseFloat(item.Percentage || 0));
    const doughnutLabels = validPages.map(item => item.PageName);
    
    const colorPalette = ['#CBA370', '#E8BB81', '#FFD5A0', '#ffdcb092'];

    const doughnutOptions = {
        chart: {
            type: 'donut',
        },
        colors: colorPalette,
        labels: doughnutLabels,
        stroke: {
            show: false
        },
        plotOptions: {
            pie: {
                donut: {
                    size: '70%',
                    labels: {
                        show: false,
                    }
                }
            }
        },
        dataLabels: {
            enabled: false
        },
        legend: {
            show: true,
            position: 'bottom',
            horizontalAlign: 'right',
            fontSize: '10px',
            fontFamily: 'Public Sans, sans-serif',
            fontWeight: 500,
            markers: {
                width: 15,
                height: 15,
                radius: 12,
                offsetY: 2
            },
            itemMargin: {
                vertical: 8,
                horizontal: 10
            },
            labels: {
                colors: '#4B465C'
            }
        },
        tooltip: {
            enabled: true,
            y: {
                formatter: (val) => `${val}%`
            }
        },
        responsive: [{
            breakpoint: 480,
            options: {
                legend: {
                    position: 'bottom',
                    horizontalAlign: 'center'
                }
            }
        }]
    };

    return (
        <div className="col-xxl-6 col-xl-12">
            <div className="card h-100 border-0 shadow-sm" style={{ borderRadius: '15px', padding: '24px' }}>
                <h6 className="text-lg mb-20" style={{ color: '#1B5E20', fontWeight: 'bold' }}>
                        Most Used Feature
                    </h6>
                <div className="card-body p-0 d-flex justify-content-center">
                    {validPages.length > 0 ? (
                        <div style={{ width: '100%', maxWidth: '450px' }}>
                            <ReactApexChart 
                                options={doughnutOptions} 
                                series={doughnutSeries} 
                                type="donut"
                                height={400} 
                            />
                        </div>
                    ) : (
                        <div className="text-muted py-5">No data available</div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default MostUsedFeature;